"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collapse = void 0;
var types_1 = require("../types");
var defaults_1 = require("./defaults");
exports.collapse = {
    vertical: {
        keyframes: {
            height: [types_1.Variable.Height + "px", "0px"],
        },
        options: { duration: defaults_1.defaultExitDuration, easing: defaults_1.defaultEasingEnter },
    },
    horizontal: {
        keyframes: {
            width: [types_1.Variable.Width + "px", "0px"],
        },
        options: { duration: defaults_1.defaultExitDuration, easing: defaults_1.defaultEasingExit },
    },
};
